var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSair({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 1.24831C13.3333 0.861556 13.1458 0.498242 12.8208 0.263846C12.4958 0.0294495 12.075 -0.0564958 11.675 0.0372627L4.17917 1.79523C3.29167 2.00228 2.66667 2.75235 2.66667 3.6118V17.4998H1.33333C0.595833 17.4998 0 18.0584 0 18.7499C0 19.4414 0.595833 20 1.33333 20H4H12H13.3333V18.7499V1.24831ZM10.6667 9.9991C10.6667 10.6906 10.2208 11.2492 9.66667 11.2492C9.1125 11.2492 8.66667 10.6906 8.66667 9.9991C8.66667 9.30763 9.1125 8.74899 9.66667 8.74899C10.2208 8.74899 10.6667 9.30763 10.6667 9.9991ZM14.6667 4.99865H18.6667V18.7499C18.6667 19.4414 19.2625 20 20 20H22.6667C23.4042 20 24 19.4414 24 18.7499C24 18.0584 23.4042 17.4998 22.6667 17.4998H21.3333V4.99865C21.3333 3.61962 20.1375 2.49842 18.6667 2.49842H14.6667V4.99865Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSair);
export default __webpack_public_path__ + "static/media/Sair.caa6b6c49099989231253c94e32c33ad.svg";
export { ForwardRef as ReactComponent };